import React from 'react'
import { Layout } from 'antd'
import SiderNav from '../../components/SiderNav'
import ContentMain from '../../components/ContentMain'
import HeaderBar from '../../components/HeaderBar'

const { Sider, Header, Content } = Layout

class Index extends React.Component {
  state = {
    collapsed: false
  }

  toggle = () => {
    // console.log(this)  状态提升后，到底是谁调用的它
    this.setState({
      collapsed: !this.state.collapsed
    })
  }


  render() {
    // 设置Sider的minHeight可以使左右自适应对齐
    if (/Mobi|Android|iPhone/i.test(navigator.userAgent)) {
      // 当前设备是移动设备
      return (
        <div>
          <ContentMain/>
        </div>
      );

    } else {
      return (
        <div id='page'>
          <Layout>
            <Sider collapsible
              trigger={null}
              collapsed={this.state.collapsed}
            >
              <SiderNav />
            </Sider>
            <Layout>
              <Header style={{ background: '#fff', padding: '0 16px' }}>
                <HeaderBar />
              </Header>
              <Content>
                <ContentMain />
              </Content>
            </Layout>
          </Layout>
        </div>
      );
    }


  }
}
export default Index


// WEBPACK FOOTER //
// ./src/routes/Index/index.js